/**
 * @generated SignedSource<<73dea341d8c26f889f3b73145b67517c>>
 * @relayHash 8754505a41606afbd103ce28f773151b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db632164be799284dec238003fe50eb08b7ae1e79cf8c18c1417c8f960a5f010

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendedTabEntryPointRootQuery } from './RecommendedTabEntryPointRootQuery.graphql';

import isForYouNewUsersEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraForYouLandAllNewUsersRelayProvider';
import isJiraFyInvokeAgentExperimentAnalyticsEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyInvokeAgentExperimentAnalyticsRelayProvider';
import isJiraFyRecommendedAssignAgentEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyRecommendedAssignAgentRelayProvider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';

const node: PreloadableConcreteRequest<RecommendedTabEntryPointRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "db632164be799284dec238003fe50eb08b7ae1e79cf8c18c1417c8f960a5f010",
    "metadata": {},
    "name": "RecommendedTabEntryPointRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyRecommendedAssignAgentRelayProvider": isJiraFyRecommendedAssignAgentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraForYouLandAllNewUsersRelayProvider": isForYouNewUsersEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyInvokeAgentExperimentAnalyticsRelayProvider": isJiraFyInvokeAgentExperimentAnalyticsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};

export default node;
